var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: _vm.specs
        ? _vm.get(_vm.globals, "features.specs", "Specs")
        : _vm.get(_vm.globals, "features.features", "Features"),
    },
    [
      _c(
        "div",
        { staticClass: "w-full md:px-gap2 lg:container features__wrapper" },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            [
              _c("div", {
                staticClass: "w-[60vw] column px-gap",
                class: _vm.length <= 2 ? "md:w-4/12" : "md:w-3/12",
              }),
              _vm._v(" "),
              _vm.product
                ? _vm._l(_vm.product, function (feature, index) {
                    return _c(
                      "div",
                      {
                        key: index + "feature",
                        staticClass:
                          "column px-gap product__wrapper flex flex-col items-center pt-1 md:pt-4",
                        class: _vm.setColumns(feature.fields.productKey),
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "max-w-[320px] text-center" },
                          [
                            feature.fields.productInfo
                              ? _c("RichTextRenderer", {
                                  attrs: {
                                    document: feature.fields.productInfo,
                                    "node-renderers": _vm.renderNodes(),
                                    "mark-renderers": _vm.renderMarks(),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            feature.fields.productKey &&
                            feature.fields.productKey !== _vm.activeProduct.key
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "learn-more",
                                    on: {
                                      click: function ($event) {
                                        return _vm.switchProductHandler(
                                          feature.fields.productKey
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Learn more\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-white header--table-fixed fixed border-b-1 w-full" },
        [
          _c(
            "div",
            {
              staticClass:
                "w-full px-gap2 lg:container mt-0 md:mt-3 features__wrapper",
            },
            [
              _c("div", { staticClass: "flex flex-wrap -mx-gap w-full" }, [
                _c(
                  "div",
                  {
                    staticClass: "w-12/12 column px-gap hidden md:block",
                    class: _vm.length <= 2 ? "md:w-4/12" : "md:w-3/12",
                  },
                  [
                    _c("h2", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.specs
                              ? _vm.get(_vm.globals, "features.specs", "Specs")
                              : _vm.get(
                                  _vm.globals,
                                  "features.features",
                                  "Features"
                                )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }